var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"8","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"m11.561 1.177-6.5 6.393a.8.8 0 0 1-1.127-.004l-3-3 1.132-1.132 2.439 2.44L10.439.035z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }